import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import api from "../../api/axios";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import productService from "../../services/ProductService";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { useAuth } from "../../context/AuthContext";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

const statusOptions = [
  { label: "Aktif", value: 1 },
  { label: "Pasif", value: 0 },
];

export default function ProductsListPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const isSalesUser = user?.UserRole === "Sales";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showProfit, setShowProfit] = useState(false);
  const toast = useRef(null);
  const navigate = useNavigate();

  // ✔ Ürünleri yükle
  const loadProducts = () => {
    setLoading(true);
    api
      .get(apiUrl + "product/get-all-products")
      .then((res) => setProducts(res.data || []))
      .catch(() => toast.current.show({ severity: "error", summary: "Hata", detail: "Ürünler yüklenemedi!" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadProducts();
  }, []);

  // ✔ Düzenleme butonu
  const editProduct = (row) => {
    navigate(`/products/edit/${row.id}`);
  };

  // ✔ Silme (Soft Delete)
  const deleteProduct = async (row) => {

    // if (!window.confirm( row.categoryName +` adlı ürünü silmek istediğine emin misin?`)) return;

    try {
      const res = await productService.delete(row.id);

      toast.current.show({
        severity: "success",
        summary: "Başarılı",
        detail: res.data.data?.message || "Ürün silindi",
        life: 2500,
      });

      loadProducts(); // Listeyi yenile
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: err.response?.data?.message || "Silme işlemi başarısız!",
        life: 3000,
      });
    }
  };

  // ✔ İşlem Butonları Kolonu
  const actionBodyTemplate = (row) => {
    if (isSalesUser) return null;
    return (
      <div className="flex items-center gap-1 justify-center"> 
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-warning hover:bg-amber-50 w-8 h-8 p-0"
          onClick={() => editProduct(row)}
          tooltip="Düzenle"
          tooltipOptions={{ position: "top" }}
        />
      </div>
    );
  };
  const detailButtonTemplate = (row) => {
  return (
  <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-text p-button-info hover:bg-blue-50 w-8 h-8 p-0"
          onClick={() => navigate(`/products/detail/${row.id}`)}
          tooltip="Detay"
          tooltipOptions={{ position: "top" }}
        />
);
  };
  

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    productName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    stockQuantity: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
    salePrice: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
    recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-between items-center px-4 py-2 bg-slate-50 border-b border-slate-200">
        <div className="flex items-center gap-4 flex-1">
          <span className="p-input-icon-left w-full md:w-80">
            <i className="pi pi-search text-slate-400 ml-3" />
            <InputText
              value={filters["global"].value || ""}
              onChange={onGlobalFilterChange}
              placeholder="Hızlı ürün ara..."
              className="w-full rounded-xl border-slate-200 text-sm  py-2 pl-10"
            />
          </span>
         
        </div>
         <div className="flex items-center gap-2 select-none pl-5">
            <Checkbox
              inputId="showProfit"
              onChange={(e) => setShowProfit(e.checked)}
              checked={showProfit}
            />
            <label htmlFor="showProfit" className="text-xs font-black text-slate-600 uppercase tracking-tighter cursor-pointer">
              Kâr Bilgilerini Göster
            </label>
          </div>
        <div className="flex gap-2">
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Temizle"
            className="p-button-outlined p-button-secondary p-button-sm rounded-xl ml-3"
            onClick={() => setFilters({
              global: { value: null, matchMode: FilterMatchMode.CONTAINS },
              productName: { value: null, matchMode: FilterMatchMode.CONTAINS },
              categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
              stockQuantity: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
              salePrice: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
              recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
            })}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="bg-[#f8fafc] min-h-screen animate-fade-in">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden">
        {/* Header */}
        <div className="!bg-slate-300 border-b border-slate-200 px-4 py-4 md:px-6 md:py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="!bg-blue-600 p-4 rounded-xl shadow-md shadow-blue-500/20">
              <i className="pi pi-box text-white text-lg"></i>
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">Ürün Listesi</h1>
              <p className="text-slate-400 text-xs font-bold italic">Stok ve Ürün Yönetimi</p>
            </div>
          </div>
          {!isSalesUser && (
            <div className="flex gap-2">
              <Button
                label="EXCELDEN IMPORT ET"
                icon="pi pi-file-excel"
                className="!bg-emerald-600 border-none hover:!bg-emerald-700 px-5 py-2.5 rounded-xl font-black text-xs shadow-lg shadow-emerald-500/20 transition-all active:scale-95"
                onClick={() => navigate("/products/import")}
              />
              <Button
                label="YENİ ÜRÜN EKLE"
                icon="pi pi-plus"
                className="!bg-blue-600 border-none hover:!bg-blue-700 px-5 py-2.5 rounded-xl font-black text-xs shadow-lg shadow-blue-500/20 transition-all active:scale-95"
                onClick={() => navigate("/products/add")}
              />
            </div>
          )}
        </div>

        <div className="p-2 md:p-4">
          <DataTable
            value={products}
            paginator
            rows={20}
            showGridlines
            responsiveLayout="scroll"
            className="p-datatable-sm"
            filters={filters}
            onFilter={(e) => setFilters(e.filters)}
            filterDisplay="menu"
            globalFilterFields={["productName", "categoryName", "barcode"]}
            emptyMessage="Ürün bulunamadı."
            loading={loading}
            header={renderHeader()}
            rowClassName={() => "hover:bg-slate-50/80 transition-colors cursor-pointer"}
            onRowClick={(e => !isSalesUser && navigate(`/products/edit/${e.data.id}`))}
          >
            <Column
              field="productName"
              header="Ürün Adı"
              filter
              filterPlaceholder="Ürün adı ile ara..."
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
              className="py-4 px-6"
              body={(row) => (
                <div className="flex flex-col">
                   <span className="font-black text-slate-700">{row.productName}</span>
                   <span className="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">{row.categoryName || 'Kategorisiz'}</span>
                </div>
              )}
            />
            <Column
              header="Stok"
              field="stockQuantity"
              filter
              dataType="numeric"
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
              className="py-4 px-6"
              body={(row) => (
                <div className="flex items-center gap-2">
                   <span className={`font-black ${row.stockQuantity <= 5 ? 'text-red-500' : 'text-slate-600'}`}>
                    {row.stockQuantity}
                  </span>
                  <span className="text-[10px] text-slate-400 font-bold uppercase">{row.unitType}</span>
                </div>
              )}
            />
            <Column
              header="Satış Fiyatı"
              field="salePrice"
              filter
              dataType="numeric"
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
              className="py-4 px-6"
              body={(row) =>
                row.salePrice ? (
                  <span className="font-black text-slate-800">
                    {row.salePrice.toLocaleString("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    ₺
                  </span>
                ) : (
                  <span className="text-slate-300 font-bold">—</span>
                )
              }
            />
            {showProfit && (
              <Column
                header="Satış Kârı"
                field="saleProfit"
                headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
                className="py-4 px-6"
                body={(row) => row.saleProfit != null ? (
                  <span className={`font-black ${row.saleProfit > 0 ? 'text-emerald-600' : row.saleProfit < 0 ? 'text-red-600' : 'text-slate-400'}`}>
                    {row.saleProfit?.toLocaleString("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} ₺
                  </span>
                ) : (
                  <span className="text-slate-300 font-bold">—</span>
                )}
              />
            )}
            {showProfit && (
              <Column
                header="Kâr Marjı"
                field="profitMargin"
                headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
                className="py-4 px-6"
                body={(row) => row.profitMargin != null ? (
                  <Tag
                    value={`%${row.profitMargin?.toLocaleString("tr-TR", {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}`}
                    severity={row.profitMargin > 20 ? "success" : row.profitMargin > 10 ? "info" : row.profitMargin > 0 ? "warning" : "danger"}
                    className="rounded-lg font-black text-[10px] px-2 py-0.5"
                  />
                ) : (
                  <span className="text-slate-300 font-bold">—</span>
                )}
              />
            )}
            <Column
              header="Durum"
              field="recordStatus"
              filter
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
              className="py-4 px-6 text-center"
              filterElement={(options) => (
                <Dropdown
                  value={options.value}
                  options={statusOptions}
                  onChange={(e) => options.filterCallback(e.value)}
                  placeholder="Seç"
                  showClear
                  className="w-full rounded-xl border-slate-200"
                  appendTo={document.body}
                />
              )}
              body={(row) => (
                <div className="flex justify-center">
                  <Tag
                    value={row.recordStatus == 1 ? "AKTİF" : "PASİF"}
                    severity={row.recordStatus == 1 ? "success" : "secondary"}
                    className="rounded-lg font-black text-[10px] px-3 py-1 border-none"
                    style={{
                      backgroundColor: row.recordStatus == 1 ? '#dcfce7' : '#f1f5f9',
                      color: row.recordStatus == 1 ? '#166534' : '#64748b'
                    }}
                  />
                </div>
              )}
            />
            <Column
            header="Detay"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-6 text-center"
            body={detailButtonTemplate}
            style={{ textAlign: "center", width: 60 }}
            className="py-4 px-6" 
             />
            <Column
              header="İşlemler"
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-6 text-center"
              className="py-4 px-6"
              body={actionBodyTemplate}
              style={{ textAlign: "center", width: 60 }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
}
